import { useRouter } from 'vue-router'
import { usePermissionStoreWithOut } from '@/store/modules/permission'
import { filter, treeToList } from '@/utils/tree'
import { pathResolve } from '@/utils/routerHelper'
import type { RouteMeta } from 'vue-router'

const filterBreadcrumb = (routes: AppRouteRecordRaw[], parentPath = ''): AppRouteRecordRaw[] => {
  const res: AppRouteRecordRaw[] = []

  for (const route of routes) {
    const meta = route?.meta as RouteMeta
    if (meta.hidden && !meta.canTo) {
      continue
    }

    const data: AppRouteRecordRaw = { ...route }

    data.path = pathResolve(parentPath, data.path)

    if (data.children) {
      data.children = filterBreadcrumb(data.children, data.path)
    }
    if (data) {
      res.push(data)
    }
  }
  return res
}

export const useBreadcrumb = () => {
  const permissionStore = usePermissionStoreWithOut()

  // store中引用无效
  const router = useRouter()

  const menuRouters = computed(() => {
    const routers = permissionStore.getRouters
    return filterBreadcrumb(routers)
  })

  const getBreadcrumb = (route: AppRouteRecordRaw) => {
    const currentPath = route.matched.slice(-1)[0].path
    const levelList = filter<AppRouteRecordRaw>(unref(menuRouters), (node: AppRouteRecordRaw) => {
      return node.path === currentPath
    })
    return treeToList<AppRouteRecordRaw[]>(unref(levelList))
  }

  const entryObj = computed(() => {
    const result = {}
    const routes = permissionStore.getAddRouters
    routes.forEach((r) => {
      r.children?.forEach((i) => {
        const { isEntry, permissionCode, modelCode } = i.meta ?? {}
        if (isEntry) {
          result[`${permissionCode}_${modelCode || ''}`] = i.name
        }
      })
      // 一级菜单作为入口
      const { isEntry } = r.meta ?? {}
      if (isEntry) {
        const permissionCode = r.children[0]?.meta?.permissionCode
        result[`${permissionCode}_`] = r.name
      }
    })
    return result
  })

  const resolvePermission = (item) => {
    const key = item.permissionCode + '_' + (item.modelCode || '')
    return router.resolve({ name: entryObj.value[key], params: { id: item.modelCode } })
  }

  const resolveHasPermissionRoute = ({
    permissionCode,
    modelCode
  }: {
    permissionCode: string
    modelCode: string
  }) => {
    const key = permissionCode + '_' + (modelCode || '')
    if (entryObj.value[key]) {
      return router.resolve({ name: entryObj.value[key], params: { id: modelCode } })
    } else {
      return null
    }
  }

  return {
    getBreadcrumb,
    resolvePermission,
    resolveHasPermissionRoute
  }
}
